import { formatMessage } from "./format";
import { en } from "./locales/en";
import type {
  LocaleId,
  MessageKey,
  MessageMap,
  Messages,
  ParamMessageKey,
  SimpleMessageKey,
} from "./types";

export const DEFAULT_LOCALE: LocaleId = "en";

const REGISTRY = new Map<LocaleId, Messages>([[DEFAULT_LOCALE, en]]);
let activeId: LocaleId = DEFAULT_LOCALE;
let active: Messages = en;

export function registerLocale(id: LocaleId, messages: Messages): void {
  REGISTRY.set(id, messages);
  if (id === activeId) {
    active = messages;
  }
}

export function unregisterLocale(id: LocaleId): void {
  if (id === DEFAULT_LOCALE) {
    throw new Error('waterra/i18n: cannot unregister the default locale "en"');
  }
  REGISTRY.delete(id);
  if (id === activeId) {
    active = en;
    activeId = DEFAULT_LOCALE;
  }
}

export function setLocale(id: LocaleId): void {
  const next = REGISTRY.get(id);
  if (next === undefined) {
    throw new Error(`waterra/i18n: locale "${id}" is not registered`);
  }
  activeId = id;
  active = next;
}

export function getLocale(): LocaleId {
  return activeId;
}

export function listLocales(): readonly LocaleId[] {
  return [...REGISTRY.keys()];
}

export function t(key: SimpleMessageKey): string;
export function t<K extends ParamMessageKey>(key: K, params: MessageMap[K]): string;
export function t<K extends MessageKey>(key: K, params?: MessageMap[K]): string {
  const template = active[key];
  if (params === null || params === undefined) return template;
  return formatMessage(template, params);
}
